export default "__VITE_ASSET__gkw6rrpu__"